export enum HelpSelectorOption {
  FAQ = "Frequently Asked Questions",
  Aneuploidy = "Aneuploidy Screen results FAQ",
  Billing = "Billing FAQ",
  Carrier = "Carrier Screen results FAQ",
}
